export const GET_WORK_FLOW = "GET_WORK_FLOW";
export const GET_WORK_FLOW_SUCCESS = "GET_WORK_FLOW_SUCCESS";
export const GET_WORK_FLOW_ERROR = "GET_WORK_FLOW_ERROR";
export const GET_WORK_FLOW_CLEAR_DATA = "GET_WORK_FLOW_CLEAR_DATA";

export const START_WORK_FLOW = "START_WORK_FLOW";
export const START_WORK_FLOW_SUCCESS = "START_WORK_FLOW_SUCCESS";
export const START_WORK_FLOW_ERROR = "START_WORK_FLOW_ERROR";
export const START_WORK_FLOW_CLEAR_DATA = "START_WORK_FLOW_CLEAR_DATA";
